import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantDifferentResidencePage = {
  alert: {
    error: 'coapplicant-different-residence-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-different-residence-page.footer.root',
  },
  form: {
    addressLine1Input:
      'coapplicant-different-residence-page.form.address-line1-input',
    addressLine1InputError:
      'coapplicant-different-residence-page.form.address-line1-input-error',
    addressLine2Input:
      'coapplicant-different-residence-page.form.address-line2-input',
    amountInput: 'coapplicant-different-residence-page.form.amount-input',
    amountInputError:
      'coapplicant-different-residence-page.form.amount-input-error',
    cityInput: 'coapplicant-different-residence-page.form.city-input',
    cityInputError:
      'coapplicant-different-residence-page.form.city-input-error',
    h1: 'coapplicant-different-residence-page.form.h1',
    h2: 'coapplicant-different-residence-page.form.h2',
    root: 'coapplicant-different-residence-page.form.root',
    stateSelect: 'coapplicant-different-residence-page.form.state-select',
    stateSelectError:
      'coapplicant-different-residence-page.form.state-select-error',
    submitButton: 'coapplicant-different-residence-page.form.submit-button',
    zipCodeInput: 'coapplicant-different-residence-page.form.zip-code-input',
    zipCodeInputError:
      'coapplicant-different-residence-page.form.zip-code-input-error',
  },
} as const satisfies PageLocatorMap;
